import {XMLImporter} from "substance";

/**
 * IDF xml top level importer
 *
 * @extends XMLImporter
 */
class IdfImporter extends XMLImporter {
    /**
     * Get the topmost non comment element so that we can easily ignore
     * comments in the top of the xml document to convert
     *
     * @param newsItemEl
     * @returns {*}
     */
    getFirstElement(newsItemEl) {
        if (!Array.isArray(newsItemEl)) {
            return newsItemEl
        }

        return newsItemEl.find(el => el.nodeType === 'element')
    }

    /**
     * Convert a NewsML idf part into a substance document
     *
     * @param  {[BrowserDOMElement]} newsMLDoc BrowserDOMElement or array of BrowserDOMElements
     */
    convertDocument(newsMLDoc) {
        const newsItemEl = this.getFirstElement(newsMLDoc)
        const groups = newsItemEl.findAll('idf > group')
        const {api} = this.context

        groups.forEach(groupEl => {
            try {
                if (groupEl.getAttribute('type') === 'body') {
                    _moveTeaser(api, newsItemEl, groupEl)
                }
                this.convertElement(groupEl)
            }
            catch (ex) {
                console.error("Error in IdfImporter while converting IDF group elements", ex)
                throw ex
            }
        })
    }
}

/**
 * Move teaser from contentMeta section of the NewsML into the IDF group
 *
 * FIXME: Invent a "pre open hook" and move this function to teaser plugin!!!
 *
 * @param       {object} api
 * @param       {BrowserDOMElement} newsItemEl
 * @param       {BrowserDOMElement} groupEl
 */
function _moveTeaser(api, newsItemEl, groupEl) {
    const teaserTypes = api.getConfigValue('se.infomaker.ximteaser', 'types', false)
    const hasMultiTeaserSupport = teaserTypes !== false

    const queryForTypes = hasMultiTeaserSupport
        ? teaserTypes.map(({type}) => `contentMeta > metadata > object[type="${type}"]`).join(',')
        : 'contentMeta > metadata > object[type="x-im/teaser"]'

    const teaserElements = newsItemEl.findAll(queryForTypes)

    if (teaserElements && teaserElements.length >= 1) {
        if (hasMultiTeaserSupport) {
            const teaserContainerElement = newsItemEl.createElement('object')
            // If there is atleast one teaser we should create a teaser container
            teaserContainerElement.attr('type', 'x-im/teasercontainer')
            teaserContainerElement.append(teaserElements)

            const teaserPosition = api.getConfigValue('se.infomaker.ximteaser', 'teaserPosition', 'bottom')
            if (teaserPosition === 'top') {
                groupEl.insertAt(0, teaserContainerElement)
            }
            else {
                groupEl.append(teaserContainerElement);
            }
        }
        else {
            // Backwards compatibility for teaser plugin
            const teaser = teaserElements[0]
            const teaserPosition = api.getConfigValue('se.infomaker.ximteaser', 'teaserPosition', 'bottom')

            // Teaser at top
            if (teaserPosition === 'top') {
                const parent = groupEl.el
                const firstChild = groupEl.children[0]
                parent.insertBefore(teaser.el, firstChild.el)
            }
            else {
                // Teaser at the bottom
                groupEl.append(teaser);
            }
        }
    }
}

export {IdfImporter}
